import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left: form area — white/light bg */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 bg-white dark:bg-gray-950 relative">
        <div className="absolute top-4 right-4">
          <LanguageSwitch />
        </div>
        <div className="w-full max-w-[380px] mx-auto">{children}</div>
      </div>

      {/* Right: testimonial + blob background — hidden on small screens */}
      <div className="hidden md:flex flex-1 relative items-center justify-center overflow-hidden auth-panel-bg">
        <div className="auth-panel-blobs" aria-hidden>
          <span className="auth-panel-blob auth-panel-blob--teal" />
          <span className="auth-panel-blob auth-panel-blob--green" />
        </div>
        <div className="relative z-10 max-w-md mx-8">
          <blockquote className="auth-testimonial-card bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-6 sm:p-8 border border-gray-200 dark:border-gray-700">
            <p className="text-gray-800 dark:text-gray-100 text-base sm:text-lg leading-relaxed">
              &ldquo;{t('auth.testimonialQuote')}&rdquo;
            </p>
            <footer className="mt-5 flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center text-primary-600 dark:text-primary-400 font-semibold">
                {t('auth.testimonialAuthorInitial')}
              </div>
              <div>
                <cite className="not-italic font-semibold text-gray-900 dark:text-white">
                  {t('auth.testimonialAuthor')}
                </cite>
                <p className="text-sm text-gray-500 dark:text-gray-400">{t('auth.testimonialAuthorRole')}</p>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
